import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { getIn } from 'formik';
import { SrLabel } from '~helpers';
import FormInputLabel from './input/FormInputLabel';
import FormInputBar from './input/FormInputBar';
import Container from './Container';
import FormInputFeedback from './feedback/FormInputFeedback';
import InputDay from './dob/InputDay';
import InputMonth from './dob/InputMonth';
import InputYear from './dob/InputYear';
import DopInputContainer from './dob/DobInputContainer';
import DobDivider from './dob/DobDivider';
import formPropTypes from '../prop-types/formPropTypes';

var FormDateOfBirth = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(FormDateOfBirth, _React$Component);

  function FormDateOfBirth(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.hasValue = function () {
      var _this$props = _this.props,
          field = _this$props.field,
          form = _this$props.form;
      var valueDay = getIn(form.values, field.name + "Day");
      var valueMonth = getIn(form.values, field.name + "Month");
      var valueYear = getIn(form.values, field.name + "Year");
      return !!(valueDay || valueMonth || valueYear);
    };

    _this.handleFocus = function () {
      var readOnly = _this.props.readOnly;

      if (!readOnly) {
        _this.setState({
          focused: true
        });
      }
    };

    _this.handleBlur = function (event) {
      var field = _this.props.field;

      _this.setState({
        focused: false
      });

      field.onBlur(event);

      _this.setState({
        filled: _this.hasValue()
      });
    };

    _this.handleChange = function (event) {
      var field = _this.props.field;
      field.onChange(event);

      _this.setState({
        filled: _this.hasValue()
      });
    };

    _this.getError = function () {
      var _this$props2 = _this.props,
          field = _this$props2.field,
          form = _this$props2.form;
      var errorDay = getIn(form.errors, field.name + "Day");
      var errorMonth = getIn(form.errors, field.name + "Month");
      var errorYear = getIn(form.errors, field.name + "Year");
      var touchDay = getIn(form.touched, field.name + "Day");
      var touchMonth = getIn(form.touched, field.name + "Month");
      var touchYear = getIn(form.touched, field.name + "Year");
      var isSubmitted = form.submitCount > 0;

      if (errorMonth && (touchMonth || isSubmitted)) {
        return errorMonth;
      }

      if (errorDay && (touchDay || isSubmitted)) {
        return errorDay;
      }

      if (errorYear && (touchYear || isSubmitted)) {
        return errorYear;
      }

      return false;
    };

    _this.state = {
      focused: false,
      filled: false
    };
    return _this;
  }

  var _proto = FormDateOfBirth.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (this.hasValue()) {
      this.setState({
        filled: true
      });
    }
  };

  _proto.render = function render() {
    var _this$props3 = this.props,
        id = _this$props3.id,
        disabled = _this$props3.disabled,
        readOnly = _this$props3.readOnly,
        field = _this$props3.field,
        form = _this$props3.form,
        required = _this$props3.required,
        label = _this$props3.label,
        skin = _this$props3.skin;
    var _this$state = this.state,
        focused = _this$state.focused,
        filled = _this$state.filled,
        selected = _this$state.selected;
    var error = this.getError();
    var valueDay = getIn(form.values, field.name + "Day");
    var valueMonth = getIn(form.values, field.name + "Month");
    var valueYear = getIn(form.values, field.name + "Year");
    var showPlaceholder = !!(focused || !focused && filled);
    var placeholderDay = showPlaceholder && !valueDay ? 'DD' : null;
    var placeholderMonth = showPlaceholder && !valueDay ? 'MM' : null;
    var placeholderYear = showPlaceholder && !valueDay ? 'YYYY' : null;
    return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(DopInputContainer, {
      active: focused,
      disabledValue: disabled,
      readOnlyValue: readOnly,
      skin: skin
    }, /*#__PURE__*/React.createElement(SrLabel, {
      htmlFor: id + "-month"
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "dob.numericMonthOfBirth"
    })), /*#__PURE__*/React.createElement(InputMonth, {
      id: id + "-month",
      name: field.name + "Month",
      type: "tel",
      onFocus: this.handleFocus,
      onBlur: this.handleBlur,
      onChange: this.handleChange,
      value: valueMonth,
      placeholder: placeholderMonth,
      maxLength: "2",
      disabled: disabled,
      readOnly: readOnly,
      skin: skin
    }), showPlaceholder && /*#__PURE__*/React.createElement(DobDivider, {
      disabledValue: disabled,
      skin: skin
    }), /*#__PURE__*/React.createElement(SrLabel, {
      htmlFor: id + "-day"
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "dob.numericDayOfBirth"
    })), /*#__PURE__*/React.createElement(InputDay, {
      id: id + "-day",
      name: field.name + "Day",
      type: "tel",
      onFocus: this.handleFocus,
      onBlur: this.handleBlur,
      onChange: this.handleChange,
      value: valueDay,
      placeholder: placeholderDay,
      maxLength: "2",
      disabled: disabled,
      readOnly: readOnly,
      skin: skin
    }), showPlaceholder && /*#__PURE__*/React.createElement(DobDivider, {
      disabledValue: disabled,
      skin: skin
    }), /*#__PURE__*/React.createElement(SrLabel, {
      htmlFor: id + "-year"
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "dob.yearOfBirth"
    })), /*#__PURE__*/React.createElement(InputYear, {
      id: id + "-year",
      name: field.name + "Year",
      type: "tel",
      onFocus: this.handleFocus,
      onBlur: this.handleBlur,
      onChange: this.handleChange,
      value: valueYear,
      placeholder: placeholderYear,
      maxLength: "4",
      disabled: disabled,
      readOnly: readOnly,
      skin: skin
    })), /*#__PURE__*/React.createElement(FormInputLabel, {
      requiredValue: required,
      focused: focused,
      filled: filled,
      selected: selected,
      disabledValue: disabled,
      "aria-hidden": "true",
      skin: skin,
      error: error
    }, label), /*#__PURE__*/React.createElement(FormInputBar, {
      active: focused,
      skin: skin,
      error: error
    }), error && /*#__PURE__*/React.createElement(FormInputFeedback, {
      feedbackType: "error",
      id: id,
      message: error,
      skin: skin
    }));
  };

  return FormDateOfBirth;
}(React.Component);

FormDateOfBirth.defaultProps = {
  required: false,
  disabled: false,
  readOnly: false,
  skin: 'dark'
};
export default FormDateOfBirth;